import { createNgReactBridgeDirective } from '../../react-bridge'
import { AccessControlSettings } from '../../../components/access-control-settings/access-control-settings'

export const accessControlSettings = createNgReactBridgeDirective(
  'reactAccessControlSettings',
  [],
  AccessControlSettings,
  []
)
